/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';

import { PremierConstants } from 'premier-constant-service';
import styles from './WizardPageHeader.module.scss';

import messages from './WizardPageHeader.messages';
// import { Link } from '@jutro/router';

const QUOTE_TRANSACTION = [
    'RecVehProduct',
    'ProLinProduct',
    'EnvProduct',
    'EveLiaProduct',
    'ConsTraAndServProduct',
    'SpoAndRecProduct',
    'SpeLinProduct',
    'RecMarProduct',
    'SpaAndWelProduct',
    'PerProduct',
    'CybLiaProduct'
];

const COMMERCIAL_PRODUCTS = [
    'RecVehProduct',
    'ProLinProduct',
    'EnvProduct',
    'EveLiaProduct',
    'ConsTraAndServProduct',
    'SpoAndRecProduct',
    'SpeLinProduct',
    'RecMarProduct',
    'SpaAndWelProduct',
    'PerProduct',
    'CybLiaProduct'
];

const WizardPageHeader = (props) => {
    const translator = useTranslator();
    const [wizardHeaderTemplate, setWizardHeaderTemplate] = useState('');
    const [routePath, setRoutePath] = useState('');
    const [accountName, setAccountName] = useState('');
    const [quoteID, setQuoteID] = useState('');
    const [Offering, setOffering] = useState('');
    const [lobWithQuoteNumber, setLobWithQuoteNumber] = useState('');
    const [location, setLocation] = useState('');
    const {
        wizardSubmission, isSideHeader, lobFlow, displayWizardHeader
    } = props;

    useEffect(() => {
        const productCode = _.get(wizardSubmission.value, 'baseData.productCode');
        const { lineName } = PremierConstants;
        // eslint-disable-next-line security/detect-object-injection
        const lobLineName = productCode ? lineName[productCode] : '';
        const jobType = _.get(wizardSubmission.value, 'baseData.jobType');
        const lob = (jobType === 'Renewal' && `${productCode}${jobType}`)
            || (jobType === 'PolicyChange' && `${productCode}${jobType}`)
            || productCode;
        const accountNumber = _.get(wizardSubmission.value, 'baseData.accountNumber');
        const getQuoteID = _.get(wizardSubmission.value, 'quoteID') || ( _.get(wizardSubmission.value, 'jobID') || _.get(wizardSubmission.value, 'policyNumber') )
        const offeringCode = _.get(wizardSubmission.value, `lobData.${lobLineName}.selectedOffering_Ext`);
        const offerings = _.get(wizardSubmission.value, `lobData.${lobLineName}.offerings_Ext`)
        const getOffering = _.find(offerings, (offering) => offering.branchCode === offeringCode)?.branchName

        const getFirstName = _.get(wizardSubmission.value, 'lobData.accountHolder.firstName') || '';
        const getLastName = _.get(wizardSubmission.value, 'baseData.accountHolder.lastName') || '';
        const getDisplayName = _.get(wizardSubmission.value, 'baseData.accountHolder.displayName');
        const getlocation = COMMERCIAL_PRODUCTS.includes(productCode) ? _.get(wizardSubmission.value, 'baseData.policyAddress.displayName') : null;
        const getAccountDisplayName = !getDisplayName
            ? `${getFirstName} ${getLastName}`
            : getDisplayName;
        const getAccountName = _.trim(getAccountDisplayName)
            || _.get(wizardSubmission.value, 'baseData.accountHolder.contactName')
            || _.get(wizardSubmission.value, 'baseData.accountName');
        const getAccountNumber = _.concat(' - ',_.get(wizardSubmission.value, 'baseData.accountNumber'))

        if (lob && QUOTE_TRANSACTION.includes(productCode)) {
            setWizardHeaderTemplate('transaction');
        }

        /* eslint no-underscore-dangle: 0 */
        if (wizardSubmission._dtoName.indexOf('fnol') !== -1) {
            setWizardHeaderTemplate('claim');
        }

        setRoutePath(`/accounts/${accountNumber}/summary`);
        setAccountName(_.concat(getAccountName, getAccountNumber));
        setQuoteID(getQuoteID)
        setOffering(getOffering)
        setLobWithQuoteNumber(
            translator(messages[_.camelCase(lob)], {
                quoteNumber:
                    _.get(wizardSubmission.value, 'quoteID')
                    || _.get(wizardSubmission.value, 'policyNumber'),
                jobId: _.get(wizardSubmission.value, 'jobID') || ''
            })
        );
        setLocation(getlocation);
    }, [lobFlow, translator, wizardSubmission]);

    const titleContainerClass = cx({
        [styles.gwWizardPageTitle]: !isSideHeader,
        [styles.gwWizardSidePageTitle]: isSideHeader
    });

    // const categoryContainerClass = cx({
    //     [styles.gwWizardPageCategory]: !isSideHeader,
    //     [styles.gwWizardSidePageCategory]: isSideHeader
    // });

    // const associatedPageClass = cx({
    //     [styles.gwWizardPageAssociated]: !isSideHeader,
    //     [styles.gwWizardSidePageAssociated]: isSideHeader
    // });

    // const titleSeparator = isSideHeader && (
    //     <div className={styles.gwWizardSidePageTitleSeparator} />
    // );

    const productCode = _.get(wizardSubmission.value, 'baseData.productCode');

    const submissionQuote = wizardHeaderTemplate === 'transaction' && (
        <React.Fragment>
            <div className={styles.row}>
                <div className={styles.column_ext}>
                    <span className={styles.columnTitle}>{translator(messages.accountTitle)}</span>
                    {/* <div className={styles.titleSeparator} /> */}
                    <p> {accountName}</p>
                </div>
                <div className={styles.column_off}>
                    <span className={styles.columnTitle}>{translator(messages.offering)}</span>
                    {/* <div className={styles.titleSeparator} /> */}
                    <p>{Offering}</p>
                </div>
                <div className={styles.column_quote}>
                    <span className={styles.columnTitle}>{translator(messages.quoteTitle)}</span>
                    {/* <div className={styles.titleSeparator} style={{width: '3rem'}} /> */}
                    <p>{quoteID}</p>
                </div>
                <div className={styles.column_off}>
                    <span className={styles.columnTitle}>{COMMERCIAL_PRODUCTS.includes(productCode) ? translator(messages.location) : null}</span>
                    {/* <div className={styles.titleSeparator} /> */}
                    <p>{location}</p>
                </div>
            </div>

            <div className={titleContainerClass}>
                {/* <div className={categoryContainerClass}>
                {translator(messages.accountTitle)}
                <Link className={associatedPageClass} to={routePath}>
                    {accountName}
                </Link>
            <span className={styles.gwAlignLocation}>
                { COMMERCIAL_PRODUCTS.includes(productCode) ? translator(messages.location) : null }
                {location}
            </span>
            </div>               */}
                {/* {titleSeparator}
            {displayWizardHeader ? (
                <h1 className={cx(styles.wizardPageHeader, { [styles.gwWizardSidepageTitle]: isSideHeader })}>
                    {lobWithQuoteNumber}
                </h1>
            ) : (
                ''
            )} */}
            </div>
        </React.Fragment>
    );

    const claimHeader = useCallback(() => {
        const claimNumber = _.get(wizardSubmission.value, 'claimNumber', '');

        return wizardHeaderTemplate === 'claim' ? (
            <h1 className={styles.gwPageTitle}>
                {translator(messages.fnolNewClaim)}
                <span className={styles.gwClaimsWizardSpanNumber}>{claimNumber}</span>
            </h1>
        ) : null;
    }, [wizardHeaderTemplate, translator, wizardSubmission.value]);

    return (
        <React.Fragment>
            {submissionQuote}
            {claimHeader()}
        </React.Fragment>
    );
};

WizardPageHeader.propTypes = {
    wizardSubmission: PropTypes.shape({
        value: PropTypes.shape({}),
        _dtoName: PropTypes.string
    }).isRequired,
    isSideHeader: PropTypes.bool,
    lobFlow: PropTypes.string,
    displayWizardHeader: PropTypes.bool
};

WizardPageHeader.defaultProps = {
    isSideHeader: false,
    lobFlow: '',
    displayWizardHeader: true
};

export default WizardPageHeader;